import React, { createContext, useState } from 'react';

import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

export const LearnToSwimClubsStateContext = createContext();

export const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE,
  items: [],
  areItemsLoaded: false
};

const LearnToSwimClubsContextProvider = ({ children }) => {
  const stateHook = useState(INITIAL_STATE);

  return (
    <LearnToSwimClubsStateContext.Provider value={stateHook}>
      {children}
    </LearnToSwimClubsStateContext.Provider>
  );
};

export default LearnToSwimClubsContextProvider;